import Button from 'tio-reimagined/components/button';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import PslfDashboardCardInfo from 'tio-employee/components/pslf/dashboard/card-info';
import PslfDashboardTodo from 'tio-employee/components/pslf/dashboard/todo';
import PslfDashboardTodoCheckbox from 'tio-employee/components/pslf/dashboard/todo/checkbox';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import type AnswerProfileModel from 'tio-data/models/answer-profile';
import type IntlService from 'ember-intl/services/intl';
import type RouterService from '@ember/routing/router';
import urlFor from 'ember-router-helpers/helpers/url-for';
import { PhArrowsClockwise } from 'ember-phosphor-icons';

export interface RecommendationsConsolidationTodoSignature {
  Args: {
    answerProfile: AnswerProfileModel;
  };
}

export default class RecommendationsConsolidationTodoComponent extends Component<RecommendationsConsolidationTodoSignature> {
  @service declare router: RouterService;
  @service declare intl: IntlService;

  get answerProfile() {
    return this.args.answerProfile;
  }

  get isCompleted() {
    return this.answerProfile?.consolidatedLoansAt ? true : false;
  }

  get linkToRec() {
    return this.idrOrPslfRoute('link');
  }

  get textForRecCard() {
    return this.idrOrPslfRoute('text');
  }

  idrOrPslfRoute = (option: 'link' | 'text') => {
    if (option === 'link') {
      return this.router.currentRouteName === 'authenticated.idr.dashboard.index'
        ? 'authenticated.idr.dashboard.recommendations'
        : 'authenticated.pslf.dashboard.recommendations';
    }
    if (option === 'text') {
      return this.router.currentRouteName === 'authenticated.pslf.dashboard.index'
        ? this.intl.t('recommendations.required')
        : this.intl.t('recommendations.consolidate_idr');
    }
  };

  toggleCompleted = async () => {
    const profile = this.answerProfile;
    try {
      profile.consolidatedLoansAt = this.isCompleted ? '' : new Date().toISOString();

      await profile.save();
    } catch (e) {
      console.error(e);
      profile?.rollbackAttributes();
    }
  };

  <template>
    <PslfDashboardTodo
      @title={{t "recommendations.consolidate_loans"}}
      @isComplete={{this.isCompleted}}
    >
      <:leftHeader>
        <PslfDashboardTodoCheckbox
          @checked={{this.isCompleted}}
          @onClick={{this.toggleCompleted}}
        />
      </:leftHeader>
      <:body>
        <PslfDashboardCardInfo
          @icon={{PhArrowsClockwise}}
          @text={{this.textForRecCard}}
          class="w-fit"
        />
      </:body>
      <:actions>
        <Button
          @intent="primary"
          @appearance="outlined"
          {{on
            "click"
            (transitionTo (concat (urlFor this.linkToRec) "?recommendation=consolidation"))
          }}
        >
          {{t "recommendations.consolidate_loans"}}
        </Button>
      </:actions>
    </PslfDashboardTodo>
  </template>
}
